var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLikedMutualAvatarDesktop(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "58px",
    height: "58px",
    viewBox: "0 0 58 58",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icLikedMutualAvatarDesktop") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("circle", {
    id: "path-1",
    cx: 25,
    cy: 25,
    r: 25
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-13.0%",
    y: "-11.0%",
    width: "126.0%",
    height: "126.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.3 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M2.97255735,11.1666786 C0.432010819,13.8954917 0.434919935,18.2761303 2.97255735,21.0071025 L13.3346108,32.1607675 C13.4363751,32.2711866 13.577934,32.3337469 13.7260215,32.3337469 C13.874109,32.3337469 14.0156679,32.2711866 14.1174322,32.1607675 C17.5747542,28.4472013 21.0305413,24.7294051 24.4878903,21.0157559 C27.0284369,18.2868958 27.0284369,13.9041755 24.4878903,11.1753181 C21.9473706,8.4464636 17.7943655,8.44640278 15.2538189,11.1753181 L13.7302236,12.8081919 L12.2066552,11.1666786 C10.9363684,9.80224995 9.25780885,9.1191067 7.58539074,9.1191067 C5.91297265,9.1191067 4.24281719,9.80224719 2.97255735,11.1666786 Z",
    id: "path-4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.8111725,0.930714503 C21.61147,2.17108408 21.6128437,4.16228343 22.8111725,5.40363447 L27.7043644,10.4734822 C27.7524198,10.5236727 27.819267,10.5521092 27.8891972,10.5521092 C27.9591274,10.5521092 28.0259747,10.5236727 28.0740301,10.4734822 C29.7066543,8.78549753 31.3385538,7.09559018 32.9711909,5.40756781 C34.1708934,4.16717688 34.1708934,2.17503126 32.9711909,0.934641568 C31.7715009,-0.305746861 29.8103596,-0.305774508 28.6106571,0.934641568 L27.8911815,1.67685693 L27.1717187,0.930714503 C26.571861,0.310519659 25.7792079,0 24.9894549,0 C24.1997019,-1.42865807e-14 23.4110174,0.310518403 22.8111725,0.930714503 Z",
    id: "path-6"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "RHP-Search--Desktop-v2",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icLikedMutualAvatarDesktop",
    transform: "translate(4.000000, 3.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#7BCB45",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-20",
    transform: "translate(8.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-5",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-4"
  })), /*#__PURE__*/React.createElement("use", {
    id: "path-1",
    fill: "#FFFFFF",
    xlinkHref: "#path-4"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask-7",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-6"
  })), /*#__PURE__*/React.createElement("use", {
    id: "path-3",
    fill: "#FFFFFF",
    xlinkHref: "#path-6"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLikedMutualAvatarDesktop);
export default __webpack_public_path__ + "static/media/icLikedMutualAvatarDesktop.52eb3982f8790fd57a79feff487d6fca.svg";
export { ForwardRef as ReactComponent };